var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('redirect-page',{attrs:{"path":"/trips"}})],1)}
__vue__options__.staticRenderFns = []
